import type { SVGProps } from 'react'
const SvgSyLocationSolid = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M12.1 11.9c.6 0 1.1-.2 1.6-.7.4-.4.7-1 .7-1.6s-.2-1.1-.7-1.6-1-.7-1.6-.7-1.1.2-1.6.7-.7 1-.7 1.6.2 1.1.7 1.6c.4.4 1 .7 1.6.7m0 11.2c-3-2.6-5.3-4.9-6.7-7.1s-2.2-4.2-2.2-6.1c0-2.8.9-5 2.7-6.7S9.8.7 12.2.7s4.5.8 6.3 2.5 2.7 3.9 2.7 6.7-.7 3.9-2.2 6.1-3.7 4.6-6.7 7.1z" />
	</svg>
)
export default SvgSyLocationSolid
